// extracted by mini-css-extract-plugin
export default {"wrapper":"EugQBosFmH95boh__qeg"};